import { _ as __read } from '../../../tslib.es6-14c74580.js';

var toDecimal = function (num) {
    if (num === void 0) { num = 0; }
    var strNum = num.toString();
    var _a = __read(strNum.split('.'), 2), _b = _a[0], leftSide = _b === void 0 ? '' : _b, _c = _a[1], rightSide = _c === void 0 ? '' : _c;
    return [Number("".concat(leftSide).concat(rightSide)), Math.pow(10, rightSide.length)];
};
var multiply = function (num_1, num_2) {
    if (num_1 === void 0) { num_1 = 0; }
    if (num_2 === void 0) { num_2 = 0; }
    var _a = __read(toDecimal(num_1), 2), int_1 = _a[0], pow_1 = _a[1];
    var _b = __read(toDecimal(num_2), 2), int_2 = _b[0], pow_2 = _b[1];
    return (int_1 * int_2) / (pow_1 * pow_2);
};
var divide = function (num_1, num_2) {
    if (num_1 === void 0) { num_1 = 0; }
    if (num_2 === void 0) { num_2 = 0; }
    var _a = __read(toDecimal(num_1), 2), int_1 = _a[0], pow_1 = _a[1];
    var _b = __read(toDecimal(num_2), 2), int_2 = _b[0], pow_2 = _b[1];
    var internalDivide = function (a, b) { return a * Math.pow(b, -1); }; // A denominator is simply a number to the power of negative 1.
    return internalDivide(internalDivide(int_1, int_2), internalDivide(pow_1, pow_2));
};
var calculateBaseNumber = function (num_1, num_2) {
    var getRightSideLength = function (num) { return (num.toString().split('.')[1] || '').length; };
    return Math.pow(10, Math.max(getRightSideLength(num_1), getRightSideLength(num_2)));
};
var plus = function (num_1, num_2) {
    if (num_1 === void 0) { num_1 = 0; }
    if (num_2 === void 0) { num_2 = 0; }
    var baseNum = calculateBaseNumber(num_1, num_2);
    return divide(multiply(num_1, baseNum) + multiply(num_2, baseNum), baseNum);
};
var minus = function (num_1, num_2) {
    var baseNum = calculateBaseNumber(num_1, num_2);
    return divide(multiply(num_1, baseNum) - multiply(num_2, baseNum), baseNum);
};
var toFixed = function (num, precisionPoint) {
    if (num === void 0) { num = 0; }
    if (precisionPoint === void 0) { precisionPoint = 2; }
    var strNum = num.toString();
    var _a = __read(strNum.split('.'), 2), leftSide = _a[0], rightSide = _a[1];
    var rSide = rightSide ? ".".concat(rightSide.slice(0, precisionPoint)) : '';
    return Number("".concat(leftSide).concat(rSide));
};

export { divide, minus, multiply, plus, toDecimal, toFixed };
